import { useApplicantAPI } from "@certn/api";
import { useFlags } from "launchdarkly-react-client-sdk";

export function useReferralCode() {
  const { enableConsumerDiscountCodes } = useFlags();
  const { data } = useApplicantAPI(
    enableConsumerDiscountCodes
      ? "/api/internal/applicant/me/referral-code/"
      : null,
    {},
    { shouldRetryOnError: false }
  );

  return {
    isFlagEnabled: Boolean(enableConsumerDiscountCodes),
    code: data?.code,
    shareUrl: data?.share_url,
  };
}
